var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.Pagination.page,"page-size":_vm.Pagination.page_size,"layout":"prev, pager, next","total":_vm.Pagination.total,"background":""},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }